import { Component } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { UIElementsModule } from '../../ui-elements/ui-elements.module';
import { DialogContainerComponent } from '../dialog-container/dialog-container.component';

@Component({
  selector: 'app-discard-changes-dialog',
  templateUrl: './discard-changes-dialog.component.html',
  styleUrls: ['./discard-changes-dialog.component.scss'],
  standalone: true,
  imports: [DialogContainerComponent, TranslateModule, MatDialogModule, UIElementsModule],
})
export class DiscardChangesDialogComponent {}
